import { useLanguage } from "@/i18n/LanguageContext";
import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Hero() {
  const { t } = useLanguage();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="min-h-screen flex items-center pt-16 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left - Text */}
          <div className="space-y-8 lg:pr-8">
            <div>
              <h1
                data-testid="hero-title"
                className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-none text-gray-900 font-heading"
              >
                {t.hero.title}
                <br />
                <span className="text-red-600">{t.hero.titleHighlight}</span>
              </h1>
            </div>
            <p
              data-testid="hero-subtitle"
              className="text-base sm:text-lg leading-relaxed text-gray-600 font-body max-w-lg"
            >
              {t.hero.subtitle}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                data-testid="hero-download-btn"
                onClick={() => scrollTo("download")}
                className="rounded-none bg-red-600 hover:bg-red-700 text-white font-bold text-base px-8 py-6 font-body"
              >
                {t.hero.downloadBtn}
              </Button>
              <Button
                data-testid="hero-learn-more-btn"
                variant="outline"
                onClick={() => scrollTo("about")}
                className="rounded-none border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white font-bold text-base px-8 py-6 font-body"
              >
                {t.hero.learnMore}
                <ArrowDown className="w-4 h-4 ml-2" />
              </Button>
            </div>
          </div>

          {/* Right - Image */}
          <div className="relative">
            <div className="aspect-[4/3] overflow-hidden border border-gray-200">
              <img
                src="https://customer-assets.emergentagent.com/job_van-rental-hub-1/artifacts/y9x9mjrz_WhatsApp%20Image%202026-04-15%20at%2020.14.08.jpeg"
                alt="RentComing van"
                className="w-full h-full object-cover"
                data-testid="hero-image"
              />
            </div>
            {/* Decorative red block */}
            <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-red-600 -z-10 hidden lg:block" />
          </div>
        </div>
      </div>
    </section>
  );
}
